<div class="alert" [ngClass]="type ? type : 'alert-info'" role="alert">
    <h6 class="alert-heading" *ngIf="heading">{{heading}}</h6>
    <p class="mb-0" *ngIf="message">{{message}}</p>
</div>